import React, { Component } from "react";
import DefaultFooter from "../CommonUtils/DefaultFooter";
import InitialFormDetails from "./InitialFormDetails";
import './InitialFormStyleSheet.css';
import { InputGroup, FormControl, Button, Image } from 'react-bootstrap';

class InitialFormContainer extends Component {

    render() {
        return (
            <div className="s360-initial-form-detail-container" style={this.allConversationContainerStyle()}>
                <div className="s360-initial-form-detail-container-introductionMessage" style={this.allConversationStyle()}>
                    {this.props.config.configDetails.introductionMessage}
                </div>
                <InitialFormDetails {...this.props} />
                <DefaultFooter      {...this.props} />
            </div>
        );
    }

    allConversationContainerStyle = () => {
        return {
            backgroundColor: this.props.config.designDetails.pageBackgroundColor
        }
    }

    allConversationStyle = () => {
        return {
            // color:      this.props.config.designDetails.headerMessageFontColor,
            fontFamily: this.props.config.designDetails.messageFont,
            fontSize:   this.props.config.designDetails.messageFontSize+"px",
            color:      this.props.config.designDetails.messageFontColor
        }
    }
}

export default InitialFormContainer;